import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import styles from './EventListingsScreenContainer.module.scss';

import useGTMEvents from '../../../common/hooks/useGTMEvents';
import eventListingsEventConfigs from '../helpers/eventListingsGTMEvents';

import Breadcrumbs from '../../../common/components/Breadcrumbs';
import MessageBanner from '../../../common/components/MessageBanner';

import { eventListingsURL, eventListingsCreateBreadcrumbs, eventListingsEditBreadcrumbs } from '../constants';
import EventListingService from '../services/EventListingService';

const EventListingsScreenContainer = () => {
  const { token } = useParams();
  const { status } = window.eventListings;

  const location = useLocation();
  const isNotConfirmationPage = !location.pathname.includes('/confirmation');
  const currentRoute = location?.pathname.replace(/\/$/, '').split('/').pop();

  const pushEvent = useGTMEvents(eventListingsEventConfigs);

  const [globalState, setGlobalState] = useState({ eventListingPurchase: { status } }); // API resp
  const [initialLoad, setInitialLoad] = useState(true); // triggers GET on initial load
  const [saveSuccess, setSaveSuccess] = useState(false);

  useEffect(() => {
    if (initialLoad) {
      if (token) {
        const api = new EventListingService(token);
        api.getEventListing(token).then((data) => {
          setGlobalState(data);
          setInitialLoad(false);
        });
      }
    }
  }, [token]);

  const formatDate = (date) => {
    const d = new Date(date);
    // return spelled out month, day, year e.g. January 1, 2021
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };
  const publishDate = globalState?.eventListingPurchase?.publishDate;
  const publishDateStr = publishDate ? formatDate(publishDate) : '';

  return (
    <main className={`${styles.container} skip-nav-target`}>
      <div className="row">
        {saveSuccess && (
          <div className={`column large-12 ${styles.saveSuccess}`}>
            <MessageBanner isClosable messageType="success" onClose={() => setSaveSuccess(false)}>
              <span>
                The event promotion has been updated and will be published on {publishDateStr}
              </span>
            </MessageBanner>
          </div>
        )}
      </div>
      {isNotConfirmationPage && (
        <div className="row">
          <div className={`column large-12 ${styles.breadcrumbs}`}>
            <Breadcrumbs
              ariaLabel="Press release creation breadcrumb"
              baseUrl={eventListingsURL}
              // This is the purchase_token but the common breadcrumbs component
              // expects checkoutToken
              checkoutToken={token}
              screen={currentRoute}
              screens={status === 'PAID' ? eventListingsEditBreadcrumbs : eventListingsCreateBreadcrumbs}
              status={status}
            />
          </div>
        </div>
      )}
      <Outlet context={{
        globalState,
        pushEvent,
        setGlobalState,
        setSaveSuccess,
        initialLoad,
      }}
      />
    </main>
  );
};

export default EventListingsScreenContainer;
